import { render, staticRenderFns } from "./BsMaEditInfo.vue?vue&type=template&id=e62b8622&scoped=true"
import script from "./BsMaEditInfo.vue?vue&type=script&lang=js"
export * from "./BsMaEditInfo.vue?vue&type=script&lang=js"
import style0 from "./BsMaEditInfo.vue?vue&type=style&index=0&id=e62b8622&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62b8622",
  null
  
)

export default component.exports